import type { DocumentsApiOptions } from '@/store/api/documentApi';

import { useGetDocumentsQuery } from '@/store/api/documentApi';


interface UseGetTemplatesOptions {
  enabled?: boolean;
}

export const useGetTemplates = (
  params: DocumentsApiOptions,
  options?: UseGetTemplatesOptions,
) => {
  const result = useGetDocumentsQuery(
    { ...params, template: true },
    { skip: options?.enabled === false }
  );

  return {
    ...result,
    data: result.data || { items: [], pages: 0, total: 0 },
  };
};
